{
    "component-card-search-list.empty-state.title.non-final": "<strong>이 리포지토리를 소프트웨어 컴포넌트에 연결</strong>",
    "component-card.add-chat-channel": "채팅 채널 추가",
    "component-card.chat-channels": "채팅 채널",
    "component-card.expander.show-more-link": "{formattedCount}개 더 보기"
}
